// The default '@stripe/stripe-js' entry injects https://js.stripe.com/v3 on import, i.e. on
// every page load. The 'pure' entry only loads Stripe.js when loadStripe() is called
// (checkout redirects below), which is the only place it is needed.
import { loadStripe } from '@stripe/stripe-js/pure';
import { VITE_STRIPE_PUBLISHABLE_KEY } from './constants';
import { createSubscriptionPayment, createOneTimePayment } from '../api/payment';
import { createTopUpSession } from '../api/partnerBilling';

export const boostProfile = async (paymentType: string) => {
    const stripe = await loadStripe(VITE_STRIPE_PUBLISHABLE_KEY);
    let session;
    if (paymentType === 'subscription') {
        session = await createSubscriptionPayment();
    } else {
        session = await createOneTimePayment();
    }
    if (!session?.id) return;
    try {
        await stripe?.redirectToCheckout({
            sessionId: session.id
        });
    } catch (error) {
        // redirect to error page?
    }
};

export const topUpPartnerWallet = async (amountCents: number) => {
    const stripe = await loadStripe(VITE_STRIPE_PUBLISHABLE_KEY);
    const session = await createTopUpSession(amountCents);
    if (!session?.id) return;
    try {
        await stripe?.redirectToCheckout({
            sessionId: session.id
        });
    } catch (error) {
        // redirect to error page?
    }
};
